/* Editable gallery, actual sample-page preview, modal zoom, keyboard navigation. */
(() => {
  'use strict';
  function setupGallery(root=document){
    root.querySelectorAll('[data-gallery]').forEach(gallery=>{
      if(gallery.dataset.galleryBound)return;gallery.dataset.galleryBound='1';
      const slides=[...gallery.querySelectorAll('[data-gallery-item]')];let pos=0;
      const show=()=>slides.forEach((s,i)=>{s.classList.toggle('is-active',i===pos);s.classList.toggle('js-hidden',i!==pos);});
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>{pos=(pos+1)%slides.length;show();});
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>{pos=(pos-1+slides.length)%slides.length;show();});
      if(slides.length)show();
    });
  }
  function setupPreview(root=document){
    root.querySelectorAll('[data-book-preview]').forEach(preview=>{
      if(preview.dataset.previewBound)return;preview.dataset.previewBound='1';
      const tabs=[...preview.querySelectorAll('[data-preview-tab]')];const panels=[...preview.querySelectorAll('[data-preview-panel]')];
      if(!tabs.length)return;
      let active=0,pageIndex=0;
      const activeImg=()=>{
        const panel=panels[active];if(!panel)return null;
        if(pageIndex===1){const second=panel.querySelector('[data-preview-extra] img');if(second)return second;}
        return panel.querySelector(':scope > img');
      };
      const show=()=>{
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===active));tab.tabIndex=i===active?0:-1;});
        panels.forEach((panel,i)=>{
          panel.classList.toggle('is-hidden',i!==active);
          const extra=panel.querySelector('[data-preview-extra]');
          if(extra)extra.hidden=!(active===i&&pageIndex===1);
          const primary=panel.querySelector(':scope > img');if(primary)primary.hidden=active===i&&pageIndex===1;
        });
      };
      const step=direction=>{
        const current=panels[active],has2=!!current?.querySelector('[data-preview-extra] img');
        if(direction>0 && pageIndex===0&&has2){pageIndex=1;}
        else if(direction<0&&pageIndex===1){pageIndex=0;}
        else{active=(active+direction+tabs.length)%tabs.length;pageIndex=0;}show();
      };
      tabs.forEach((tab,i)=>tab.addEventListener('click',()=>{active=i;pageIndex=0;show();}));
      preview.querySelector('[data-preview-prev]')?.addEventListener('click',()=>step(-1));
      preview.querySelector('[data-preview-next]')?.addEventListener('click',()=>step(1));
      const dialog=document.querySelector('#najah-preview-dialog');
      preview.querySelector('[data-preview-zoom]')?.addEventListener('click',()=>{
        const img=activeImg();if(!img||!dialog?.showModal){window.NajahUI?.toast('رفع نموذج صفحة حقيقية باش تقدر تكبرها.');return;}
        const node=img.cloneNode(true);node.removeAttribute('hidden');node.removeAttribute('loading');node.removeAttribute('width');node.removeAttribute('height');
        const box=dialog.querySelector('.preview-dialog__body');box.replaceChildren(node);dialog.showModal();
      });
      if(dialog){dialog.querySelector('[data-preview-close]')?.addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});}
      show();
    });
  }
  document.addEventListener('DOMContentLoaded',()=>{setupGallery();setupPreview();});
  document.addEventListener('shopify:section:load',e=>{setupGallery(e.target);setupPreview(e.target);});
})();
